<template>
  <div class="shrink-0 p-2">
    <div class="relative">
      <Icon
        name="search"
        class="pointer-events-none absolute top-1/2 left-2 size-3 -translate-y-1/2 text-burgundy-400"
      />
      <input
        v-model="searchQuery"
        type="text"
        aria-label="Search organizations"
        class="w-full rounded-md border border-burgundy-900/15 bg-white py-1.5 pr-2 pl-7 text-xs text-burgundy-900 placeholder-burgundy-400 focus:border-purple-400 focus:ring-1 focus:ring-purple-300 focus:outline-none"
        placeholder="Search organizations..."
        @click.stop
      />
    </div>
  </div>
  <div class="custom-table-scroll max-h-96 min-h-0 overflow-y-auto px-1 pb-1">
    <button
      v-for="org in filteredOrganizations"
      :key="org.id"
      class="flex !w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-xs transition-colors duration-150"
      :class="
        org.id === currentOrganization?.id
          ? 'bg-purple-50 font-medium text-purple-900'
          : 'text-burgundy-700 hover:bg-burgundy-900/5 hover:text-burgundy-900'
      "
      @click="onSelect(org.id)"
    >
      <img
        v-if="org.iconUrl"
        :src="org.iconUrl"
        alt=""
        class="size-5 shrink-0 rounded object-cover"
      />
      <div
        v-else
        class="flex size-5 shrink-0 items-center justify-center rounded bg-burgundy-900/5 text-burgundy-500"
      >
        <Icon name="building-light" class="size-3" />
      </div>
      <span class="truncate">{{ org.name }}</span>
      <span
        v-if="org.id === primaryOrganizationId"
        class="ml-auto rounded-full bg-purple-100 px-1.5 py-0.5 text-[10px] leading-none font-medium text-purple-700"
      >
        Main
      </span>
    </button>
    <div
      v-if="filteredOrganizations.length === 0"
      class="p-3 text-center text-xs text-burgundy-400"
    >
      No matches
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from "vue";
import Icon from "@/components/Core/Icon.vue";
import { useActiveOrganization } from "@/composables/useActiveOrganization";

const emit = defineEmits({ selected: () => true });

const {
  organizations,
  primaryOrganizationId,
  currentOrganization,
  selectOrganization,
} = useActiveOrganization();

function onSelect(orgId: number): Promise<void> {
  emit("selected");
  return selectOrganization(orgId);
}

const searchQuery = ref("");
const filteredOrganizations = computed(() => {
  const query = searchQuery.value.toLowerCase().trim();
  if (!query) return organizations.data ?? [];
  return (
    organizations.data?.filter((org) =>
      org.name.toLowerCase().includes(query),
    ) ?? []
  );
});
</script>
